export default __webpack_public_path__ + "static/icomoon-a515bd139c4f0d792e2c68bcb7048e7b.woff";